import useLoginCheck from 'hooks/common/useLoginCheck';
import { getStoreList } from 'lib/api/place';
import { changeProp } from 'modules/storeSlice';
import { useCallback } from 'react';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';

const usePlaceList = () => {
  const dispatch = useDispatch();

  const {
    addStoreListPage,
    storeListPage,
    addStoreListSearch,
    storeListPageSearch,
  } = useSelector(({ store: { storeList } }) => storeList);

  const { isLoading, error, data, refetch } = useQuery(
    [
      'storeList',
      addStoreListPage,
      storeListPage,
      addStoreListSearch,
      storeListPageSearch,
    ],
    () =>
      getStoreList({
        addStoreListPage,
        storeListPage,
        addStoreListSearch,
        storeListPageSearch,
      }),
    {
      keepPreviousData: true,
    },
  );

  useLoginCheck(error?.response, refetch);
  const addStoreList = data?.data.addStoreList;
  const storeList = data?.data.storeList;

  const onSearch = e => {
    const { name, value } = e.target;
    if (name === 'storeListPageSearch') {
      dispatch(changeProp({ obj: 'storeList', key: name, value }));
      dispatch(
        changeProp({ obj: 'storeList', key: 'storeListPage', value: 1 }),
      );
    } else if (name === 'addStoreListSearch') {
      dispatch(changeProp({ obj: 'storeList', key: name, value }));
      dispatch(
        changeProp({ obj: 'storeList', key: 'addStoreListPage', value: 1 }),
      );
    }
  };

  const onPaginateStore = useCallback(
    page => {
      dispatch(
        changeProp({ obj: 'storeList', key: 'storeListPage', value: page }),
      );
    },
    [dispatch],
  );

  const onPaginateAddStore = useCallback(
    page => {
      dispatch(
        changeProp({ obj: 'storeList', key: 'addStoreListPage', value: page }),
      );
    },
    [dispatch],
  );

  return {
    isLoading,
    error,
    addStoreListPage,
    storeListPage,
    addStoreListSearch,
    storeListPageSearch,
    addStoreList,
    storeList,
    onPaginateAddStore,
    onPaginateStore,
    onSearch,
  };
};

export default usePlaceList;
